export default __webpack_public_path__ + "static/media/Business_pe_pakad.5d7c95a0.gif";